export default __webpack_public_path__ + "static/media/generic-terminal.e2711ce1.svg";